import React, { useState, useEffect } from "react";
import "./MyOrders.css";
import API_URL from "../apiConfig";

const API_BASE_URL = API_URL;

const MyOrders = ({ onOrderClick, onGoShopping }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/orders/myorders`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      setOrders(data);
    } catch (err) {
      console.error("Fetch orders error:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="orders-loading container">
        <h2>Fetching your orders...</h2>
      </div>
    );

  if (orders.length === 0)
    return (
      <div className="orders-empty container">
        <img
          src="https://constant.myntassets.com/checkout/assets/img/empty-bag.webp"
          alt=""
          style={{ width: "150px", opacity: 0.6 }}
        />
        <h2>You haven't placed any orders yet</h2>
        <p>Your orders will appear here once you buy something!</p>
        <button className="continue-btn" onClick={onGoShopping}>
          START SHOPPING
        </button>
      </div>
    );

  return (
    <div className="orders-page container">
      <div className="orders-header">
        <h1>All Orders</h1>
      </div>

      <div className="orders-list">
        {orders.map((order) => (
          <div
            key={order._id}
            className="order-card"
            onClick={() => onOrderClick(order._id)}
          >
            <div className="order-card-header">
              <div className={`status-tag ${order.status.toLowerCase()}`}>
                {order.status}
              </div>
              <div className="order-date">
                Placed on{" "}
                {new Date(order.createdAt).toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })}
              </div>
            </div>

            <div className="order-content">
              <div className="order-images">
                {order.orderItems.map((item, idx) => (
                  <img
                    key={idx}
                    src={
                      item.image.startsWith("http")
                        ? item.image
                        : `${API_BASE_URL}${item.image}`
                    }
                    alt=""
                  />
                ))}
              </div>
              <div className="order-info">
                <p className="order-id">
                  Order ID: #{order._id.slice(-8).toUpperCase()}
                </p>
                <p className="order-total">Total: ₹{order.totalPrice}</p>
              </div>
              <div className="order-arrow">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyOrders;
